import PropTypes from 'prop-types';
import React, {Component} from 'react';
import BaseElement from '../BaseElement/BaseElement';
import YoutubeUrl from 'youtube-url';
import shallowEqual from 'fbjs/lib/shallowEqual';

require('./GlobalStyles/VideoElement.scss');

const missingImage = require('./images/missing-video.png');

function getVideoUrl(elementProps) {
  return elementProps.data.url;
}

function getVideoId(elementProps) {
  return elementProps.data.videoId;
}

function getVideoIdFromUrl(videoUrl) {
  return YoutubeUrl.extractId(videoUrl);
}

class VideoElement extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  render() {
    const {data, layout} = this.props;
    const {baseUrl} = data;
    const compBaseUrl = baseUrl.includes('localhost') ? '' : baseUrl;
    let videoId = '';
    if (data.videoId) {
      videoId = data.videoId;
    } else if (data.url) {
      videoId = getVideoIdFromUrl(data.url);
    }
    return (
      <BaseElement {...this.props} data={{...data, href: `https://www.youtube.com/watch?v=${videoId}`}}>
        {videoId && (
          <div
            style={{
              width: '100%',
              backgroundSize: '100% auto',
              backgroundColor: 'black',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundImage: `url("https://img.youtube.com/vi/${videoId}/0.jpg")`,
            }}
            className="video-container"
          >
            <div style={{position: 'relative'}}>
              <img style={{width: 68, height: 48}} src={'https://assets.crazylister.com/images/playButtonGrey.svg'} />
              <img
                className="red-play-button"
                style={{width: 68, height: 48, position: 'absolute', left: 0, top: 0}}
                src={'https://assets.crazylister.com/images/playButtonRed.svg'}
              />
            </div>
          </div>
        )}
        {!data.url && <img src={compBaseUrl + missingImage} style={{width: '100%', height: '100%'}} />}
      </BaseElement>
    );
  }
}

VideoElement.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
  data: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    compProps: PropTypes.object,
  }),
};

VideoElement.defaultProps = {
  data: {
    title: '',
  },
};

export default {
  elementClass: VideoElement,
  methods: {
    getVideoId: getVideoId,
    getVideoUrl: getVideoUrl,
    getVideoIdFromUrl: getVideoIdFromUrl,
  },
};
